const DATA = [
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: "Mode 1 chosen for Training",
  },
  {
    color: "#57FC14",
    end: false,
    error: false,
    message: "Reading dataset locally...",
  },
  {
    color: "#57FC14",
    end: false,
    error: false,
    message: "Dataset read successfully",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: "Shape of the dataset: (20473, 9)",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message:
      "Columns present in the dataset: Index(['reviewerID', 'asin', 'reviewerName', 'helpful', 'reviewText',\n       'overall', 'summary', 'unixReviewTime', 'reviewTime'],\n      dtype='object')",
  },
  {
    color: "#57FC14",
    end: false,
    error: false,
    message: "Preprocessing dataset...",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Converting NA values in review column to 'Missing'",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message:
      ">Creating a new column called 'reviews', combining the reviewText and summary columns",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message:
      ">Converting star values to ['Positive', 'Negative', 'Neutral'] Sentiments",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message:
      ">Splitting date into year, date and adding them as seperate columns",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Creating the 'helpfulness column",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Cleaning review text by removing punctuation and stop words",
  },
  {
    color: "#57FC14",
    end: false,
    error: false,
    message: "Preprocessing complete...",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: "Shape of the dataset: (20473, 12)",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message:
      "Columns present in the dataset: Index(['reviewerID', 'asin', 'reviewText', 'overall', 'summary', 'reviewTime',\n       'reviews', 'sentiment', 'year', 'month', 'day', 'helpful_rate'],\n      dtype='object')",
  },
  {
    color: "#57FC14",
    end: false,
    error: false,
    message: "Commencing Data visualization tasks and image generation",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Plotting Sentiment vs helpful rate..",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Plotting Year vs number of reviews..",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Plotting Day vs number of reviews..",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Plotting Sentiment Polarity distribution..",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Plotting Review Rating distribution..",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Plotting Review length distribution..",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Plotting Review word count distribution..",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Generating word count plots..",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Generating word cloud plots..",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Saved All plots locally",
  },
  {
    color: "#57FC14",
    end: false,
    error: false,
    message: "Data visualization complete...",
  },
  {
    color: "#57FC14",
    end: false,
    error: false,
    message: "Commencing Model training experiments...",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Performing stemming on the reviews",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Performing TF-IDF on the reviews",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Performing SMOTE on the reviews",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: ">>Original dataset shape: Counter({2: 17895, 1: 1430, 0: 1148})",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message:
      ">>Resampled dataset shape: Counter({2: 17895, 1: 17895, 0: 17895})",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Performing Grid Search on models",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: ">>Logistic Regression Accuracy = 0.8863562357538262",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: ">>Logistic Regression F1 Score = 0.8424633208607468",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: ">>Logistic Regression Recall = 0.8863562357538262",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: ">>Logistic Regression Precision = 0.8504828510964706",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: ">>Decision Tree Accuracy = 0.8316509280364702",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: ">>Decision Tree F1 Score = 0.8249814235680822",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: ">>Decision Tree Recall = 0.8316509280364702",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: ">>Decision Tree Precision = 0.8189590981243983",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: ">>KNN Accuracy = 0.8782155649625529",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: ">>KNN F1 Score = 0.829134089107887",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: ">>KNN Recall = 0.8782155649625529",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: ">>KNN Precision = 0.808509524466352",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: ">>Naive Bayes Accuracy = 0.8248127645718007",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: ">>Naive Bayes F1 Score = 0.8242872852138847",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: ">>Naive Bayes Recall = 0.8248127645718007",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: ">>Naive Bayes Precision = 0.8238918052355539",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Performing Grid Search on hyperparameters (Logistic Regression)",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">>The mean accuracy of the model is: 0.9097004917299956",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Accuracy of logistic regression classifier on test set: 0.92",
  },
  {
    color: "#57FC14",
    end: false,
    error: false,
    message: ">Plotting ROC curve",
  },
  {
    color: "#57FC14",
    end: false,
    error: false,
    message: "Model training experiments complete...",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: "Mode 1 chosen for Testing",
  },
  { color: "#57FC14", end: false, error: false, message: "Creating test set" },
  { color: "#57FC14", end: false, error: false, message: "Test set created" },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: "Shape of test set: (249,1)",
  },
  {
    color: "#57FC14",
    end: false,
    error: false,
    message: "Running test set on model..",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Preprocessing test set (stemming and removal of stopwords)",
  },
  {
    color: "#57FC14",
    end: false,
    error: false,
    message: ">Saving features for future processing",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Creating TF-IDF feature matrix",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Creating model with new TF-IDF feature matrix",
  },
  {
    color: "#14FCB9",
    end: false,
    error: false,
    message: ">Prediction complete",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: ">Accuracy of model on test set: 0.9156626506024096",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: ">Precision of model on test set: 0.8633390705679862",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: ">Recall of model on test set: 0.9156626506024096",
  },
  {
    color: "#FFFF00",
    end: false,
    error: false,
    message: ">F1 of model on test set: 0.888731396172927",
  },
  {
    color: "#57FC14",
    end: true,
    error: false,
    message: "All operations completed successfully. Exiting program..",
  },
];

export default DATA;
